module.exports = "<div *ngIf=\"parentFormControl.invalid && parentFormControl.touched\">\r\n  <small [ngClass]=\"{'form-text': true, 'text-muted': !red, 'text-red': red}\">{{ errorMessage }}</small>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/validate-errors/validate-errors.component.html
// module id = ./src/app/shared/components/validate-errors/validate-errors.component.html
// module chunks = main